import * as Yup from "yup";

export const CreateNewCredentialValidation = Yup.object().shape({
  selectedEmployee: Yup.string()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .required("This field is required"),
});

export const ResetPasswordValidation = Yup.object().shape({
  password: Yup.string()
    .min(8, "Password must be 8 characters long")
    .matches(/[0-9]/, "Password requires a number")
    .matches(/[A-Z]/, "Password requires an uppercase letter")
    .matches(/[^\w]/, "Password requires a symbol"),
});